import React from 'react';
import RunningWithErrorsRoundedIcon from '@mui/icons-material/RunningWithErrorsRounded';
import EmphasisPopover from '@src/containers/EmphasisPopover';
import Tooltip from '@src/components/Tooltip';
import BadgeAvatar from '@src/components/BadgeAvatar';
import { Button, Divider, Typography } from '@mui/material';
import { TTS_GUIDE } from '@src/constants/tourGuide';
import SpeedNew from '@src/components/SpeedNew';
import { useTranslation } from 'react-i18next';
import { convertFormatDate } from '@src/utils/date';
import LimitedFeature from '@src/components/LimitedFeature';

const AdjustVoice = ({
  advanceFeature,
  openSentences,
  handleOpenVoices,
  voice,
  isInValidPublicVoiceCloning,
  isVoiceCloningAboutToRemoved,
  synthesisRequest,
  handleCloseSearchBoxAndMoreMenu,
  handleChangeSpeed,
  handleChangeSynthesisRequest,
  handleChangeEmphasis,
}) => {
  const isDisabledSpeedChange = advanceFeature ? openSentences : false;
  const { t } = useTranslation();

  const isDisplayEmphasisPopover =
    !openSentences && synthesisRequest?.hasEmphasis;

  return (
    <div className="group group-adjust-voice">
      <Tooltip arrow title={t('chooseVoice')} placement="top">
        <Button
          id={TTS_GUIDE.VOICE}
          onClick={handleOpenVoices}
          className="choose-voice margin-right"
          data-id="open-voice-list"
        >
          <BadgeAvatar
            width={25}
            smallImgWidth={10}
            img={voice && voice.roundImage}
            smallImg={voice && voice.language && voice.language.roundImage}
            type="image"
          />
          <Typography
            variant="body2"
            className={
              isInValidPublicVoiceCloning ? 'invalid-voice-name' : 'voice-name'
            }
          >
            {voice && voice.name}
          </Typography>
        </Button>
      </Tooltip>
      <LimitedFeature voiceFeatures={voice?.features} />
      {isVoiceCloningAboutToRemoved && (
        <Tooltip
          arrow
          title={t('voiceCloningDiscardAt', {
            date: convertFormatDate(voice?.discardAt),
          })}
          placement="top"
        >
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}
      {isInValidPublicVoiceCloning && (
        <Tooltip arrow title={t('invalidPublicVoiceCloning')} placement="top">
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}
      <SpeedNew
        currentSpeed={synthesisRequest.speed}
        disabled={isDisabledSpeedChange}
        onClick={handleCloseSearchBoxAndMoreMenu}
        onChange={
          advanceFeature ? handleChangeSpeed : handleChangeSynthesisRequest
        }
        width="55px"
        newUiSpeed
      />
      {isDisplayEmphasisPopover && (
        <EmphasisPopover
          currentEmphasis={synthesisRequest?.emphasis || 0}
          onChangeEmphasis={handleChangeEmphasis}
        />
      )}
      <Divider
        orientation="vertical"
        flexItem
        className="divider hide-divider"
      />
    </div>
  );
};

export default AdjustVoice;
